module.exports = __webpack_public_path__ + "static/media/transparent_delete.3b752fcd.svg";